<i18n src="./resources/locales.json"></i18n>
<template>
  <div>
    <v-btn class="compose-new-email-button" color="accent" fab @click.stop="onFabClick">
      <v-icon v-if="visible">mdi-email-send</v-icon>
      <v-icon v-else>mdi-email-plus-outline</v-icon>
    </v-btn>
    <v-overlay class="compose-new-email-overlay" :value="visible" absolute>
      <div class="compose-new-email-container" @click="onClickOutside">
        <div class="compose-new-email-content">
          <div v-once class="hidden-div">
            {{ $t('businessProcess') }}
          </div>
          <v-select
            hide-details
            :items="items"
            :label="$t('businessProcess')"
            :menu-props="{ top: true }"
            :value="selectedBusinessProcess"
            @click.stop
            @change="onSelectChange"
          ></v-select>
          <v-text-field
            ref="email"
            autofocus
            class="mt-5"
            type="email"
            :rules="[isEmailEmpty, isEmailValid]"
            :label="$t('enterEmail')"
            :value="email"
            @click.stop
            @change="onEmailChange"
          ></v-text-field>
        </div>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { emailsRegExp } from '@/components/ecs-email/EcsEmail';

export default {
  name: 'EcsComposeEmail',
  props: {
    emailBusinessProcess: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      visible: false,
      selectedBusinessProcess: '',
      email: '',
      contactId: null
    };
  },

  computed: {
    ...mapGetters('BUSINESS_PROCESSES', ['availableBusinessProcesses']),

    ...mapGetters('SETTINGS', ['agentSettings']),

    items() {
      return this.availableBusinessProcesses
        .filter(bp => bp.outgoingMediaTypes.includes('Email'))
        .map(bp => {
          return { text: bp.name, value: bp.id };
        });
    }
  },

  watch: {
    visible(newValue) {
      if (newValue) {
        this.selectedBusinessProcess = this.agentSettings.defaultOutgoingEmailBusinessProcessId;
      }
    }
  },

  created() {
    this.$root.$on('open-compose-email', this.handleOpenComposeEmail);
  },

  destroyed() {
    this.$root.$off('open-compose-email', this.handleOpenComposeEmail);
  },

  methods: {
    ...mapActions('INTERACTIONS/emails', ['createOutgoingEmail']),
    ...mapActions('WINDOWS', ['setFocusedInteractionId']),

    onSelectChange(value) {
      this.selectedBusinessProcess = value;
    },

    onClickOutside() {
      this.visible = false;
    },

    onFabClick() {
      if (this.visible) {
        this.createEmail();
      } else {
        this.visible = true;
      }
    },

    isEmailValid(value) {
      return emailsRegExp.test(value) || this.$t('invalidEmail');
    },

    isEmailEmpty(value) {
      return value.length > 0 || this.$t('emptyEmail');
    },

    onEmailChange(value) {
      this.email = value;
    },

    createEmail() {
      if (!this.$refs.email.valid) {
        return;
      }
      const params = {
        businessProcessId: this.selectedBusinessProcess,
        destination: this.contact ? null : this.email,
        contactId: this.contact ? this.contact.id : null
      };

      this.createOutgoingEmail(params)
        .then(email => {
          this.setFocusedInteractionId(email.interactionId);
          this.email = '';
          this.visible = false;
          this.contact = null;
        })
        .catch(() => {
          const errorMessage = `${this.$t('unableToEmailContact', {
            name: this.contact.name,
            email: this.email
          })}`;
          this.$root.$emit('snackbar-message', {
            message: this.contact ? errorMessage : this.$t('unableToStartEmailInteraction'),
            type: 'error'
          });
        });
    },

    handleOpenComposeEmail(contact, email) {
      console.log('handleOpenComposeEmail', { contact, email });
      this.contact = contact;
      this.email = email;
      this.visible = true;
    }
  }
};
</script>

<style scoped>
.compose-new-email-button {
  position: fixed;
  right: 12px;
  bottom: 60px;
  z-index: 10;
}
.hidden-div {
  height: 0;
  visibility: hidden;
  white-space: nowrap;
  font-size: 20px;
}
</style>
<style>
.compose-new-email-overlay .v-overlay__content,
.compose-new-email-container {
  height: 100%;
  width: 100%;
}
.compose-new-email-content {
  z-index: 10;
  position: absolute;
  bottom: 130px;
  right: 16px;
}
</style>
